module.exports = __webpack_public_path__ + "static/media/meter-notnormal.4bd6d55d.png";